import React, { useState, useEffect, useRef } from "react";
import {
  initiateSocketConnection,
  subscribeToMessages,
  joinChatRoom,
  disconnectSocket,
  sendMessage,
} from "./chatService";
import api from "../../api";
import { Send } from "lucide-react";
import { useAlert } from "react-alert";

export const ChatContainer = ({
  sessionId,
  userToken,
  setShowChat,
  isEnded,
}) => {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [chatDisabled, setChatDisabled] = useState(false);
  const [loader, setLoader] = useState(false);
  const chatEndRef = useRef(null);
  const alert = useAlert();
  // Auto-scroll to bottom whenever messages update
  // 1. Create a Ref for the container itself
  const chatContainerRef = useRef(null);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      const container = chatContainerRef.current;
      // Set the scroll position to the very bottom
      container.scrollTo({
        top: container.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    // Connect only when this component mounts (which is when isLive is true)

    // subscribeToMessages((data, isHistory) => {
    //   console.log(data);

    //   if (isHistory) {
    //     setMessages(data);
    //   } else if (data.type === "error" && data.message === "Session ended") {
    //     setChatDisabled(true); // Disable the UI
    //   } else {
    //     setMessages((prev) => [...prev, data]);
    //   }
    // });

    // subscribeToMessages((data, isHistory) => {
    //   console.log("Chat Data Received:", data);
    //   if (
    //     data === "Session ended" ||
    //     data === "The live chat for this session has ended."
    //   ) {
    //     setChatDisabled(true);
    //     return; // Stop here so it doesn't touch the messages array
    //   }

    //   if (isHistory === "history") {
    //     setMessages(Array.isArray(data) ? data : []);
    //   }
    //   else {
    //     if (data && typeof data === "object") {
    //       setMessages((prev) => [...prev, data]);
    //     }
    //   }
    // });
    if (!sessionId || !userToken) return;
    if (isEnded) {
      setChatDisabled(true);
      getChatHistory();
    } else {
      initiateSocketConnection(userToken);
      joinChatRoom(sessionId);
      subscribeToMessages((data, type) => {
        // 1. Handle History (Incoming Array)
        console.log(type);
        if (type === "history") {
          setMessages(Array.isArray(data) ? data : []);
        }
        // 2. Handle Real-time Message (Incoming Object)
        else if (type === "message") {
          if (data && typeof data === "object") {
            setMessages((prev) => [...prev, data]);
          }
        }
        // 3. Handle Session Ended (Error/Status String)
        else if (type === "chat_ended") {
          setChatDisabled(true);
          getChatHistory();
          alert.error("This chat is now closed.");
        } else if (type === "error" || type === "session_ended") {
          if (
            data === "Session ended" ||
            data === "The live chat for this session has ended."
          ) {
            setChatDisabled(true);
            getChatHistory();
          }
        }
      });

      return () => disconnectSocket();
    }
  }, [sessionId, isEnded]);

  const handleSend = () => {
    if (text.trim()) {
      sendMessage(sessionId, text);
      setText("");
    }
  };

  const getChatHistory = async () => {
    try {
      setLoader(true);
      const res = await api.getChatHistory(sessionId);
      // console.log(res);
      setMessages(Array.isArray(res) ? res : []);
      setLoader(false);
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  const getInitials = (username) => {
    if (!username || typeof username !== "string") return "U";

    // Get the first character and convert to uppercase
    return username.charAt(0).toUpperCase();
  };

  return (
    <div className="chat-box-wrapper">
      <div className="closeIco" onClick={() => setShowChat(false)}>
        <i className="fas fa-close"></i>
      </div>
      <div className="heading">Chat</div>
      <div className="chat-messages" ref={chatContainerRef}>
        {Array.isArray(messages) &&
          messages.map((m, i) => (
            <div
              key={i}
              className={`chat-msg mb-2 ${m?.email == "techsupport@waqarzaka.net" ? "admin-highlight" : ""}`}
            >
              <div className="profileIco">{getInitials(m.username)}</div>
              <div>
                <span className="fw-bold me-2 text-capitalize">
                  {m.username}
                  {m?.email == "techsupport@waqarzaka.net" && (
                    <span className="host">(Host)</span>
                  )}
                  :{" "}
                </span>{" "}
                {m.text}
              </div>
            </div>
          ))}
        {/* Invisible element to anchor the scroll */}
      </div>
      {chatDisabled || isEnded ? (
        <div className="alert alert-secondary">This chat is now closed.</div>
      ) : (
        <div className="chat-input-area d-flex">
          <textarea
            rows={1}
            placeholder="Chat here ..."
            className="form-control"
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleSend()}
          ></textarea>
          <button
            className="sendBtn"
            onClick={handleSend}
            disabled={text ? false : true}
          >
            <Send />
          </button>
        </div>
      )}
    </div>
  );
};
